import axios, { AxiosRequestConfig, isCancel } from 'axios';
import { errorToast } from '@/utils/toast';
import { ApiResp, ApiType, ApiUrls } from '@/config/api';
import { clearLoginMes } from '.';

export const API_PREFIX = '';
export const axiosClient = axios.create({
  baseURL: '/',
  timeout: 20 * 1000,
  timeoutErrorMessage: '网络异常，请稍后重试',
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

axiosClient.interceptors.request.use((config) => {
  config.headers['Authorization'] = `Bearer ${sessionStorage.getItem('videoAudit-b-token')}` || '';
  return config;
});

axiosClient.interceptors.response.use(
  
  (response: any) => {
    if (!response?.config?.hideTip && response?.data?.code !== 0) {
      errorToast(response?.data?.msg || '系统繁忙，请稍后重试');
    }
    if (isCancel(response)) {
      throw response;
    }
    return response.data;
  },
  (error: unknown) => {
    if (isCancel(error)) {
      throw error;
    }

    const res = (error as any).response;
    const { origin } = window.location;
    if (res.data?.code === 401 && window.location.href !== `${origin}/login`) {
      clearLoginMes(res.data.message);
      return;
    }
    if (!(error as any).config?.hideTip) {
      const msg = ((error as any)?.response?.data?.error?.message) || (error as any).message || `系统繁忙，请稍后重试 ${res?.status ? `[status:${res.status}]` : ''}`;
      errorToast(msg);
    }
    console.error('❗ ~ file:axios.ts line:33 ----- error', error);
    throw error;
  },
);
interface RequestConfigCommon extends Omit<AxiosRequestConfig, 'url'> {
  hideTip?: boolean;
}
// @ts-ignore
export function request<T extends ApiType>(config: RequestConfigCommon & {apiType: T}): Promise<ApiResp[T]>;
export function request<D = any>(config: RequestConfigCommon & {url: string}): Promise<D>;
export async function request(config: any): Promise<any> {
  const { apiType, method = 'GET' } = config;
  const successFunc = (data: any) => {
    // if (data?.code === -3) {
    //   const { origin } = window.location;
    //   sessionStorage.removeItem('videoAudit-b-token');
    //   sessionStorage.removeItem('videoAudit-b-pageStatus');
    //   window.location.href = `${origin}/login`;
    // } else if (data?.code === -1) {
    //   errorToast(data?.msg || '系统繁忙，请稍后重试');
    // }
    return data;
  }
  if (apiType) {
    const url: string = ApiUrls[apiType as ApiType];
    return axiosClient.request({ ...config, method, url }).then(successFunc);
  }

  return axiosClient.request({ ...config }).then(successFunc);
}
